import React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { ProductsData } from "../models/types";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import ProductCard from "./ProductCard";
import { Box } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'nowrap',
      gap: theme.spacing(2),
      overflowX: 'auto',
      overflowY: 'hidden',
      paddingBottom: theme.spacing(1),
      WebkitOverflowScrolling: 'touch',
    },
    productTile: {
      flex: '0 0 calc((100% - 48px) / 4)',
      minWidth: '220px',
      maxWidth: '320px',
      [theme.breakpoints.down('sm')]: {
        flexBasis: 'calc((100% - 16px) / 2)',
        minWidth: '210px',
      },
      [theme.breakpoints.down('xs')]: {
        flexBasis: '78%',
        minWidth: '210px',
      },
    },
    sliderBox: {
        backgroundColor: '#f9f9f9',
        color: '#000000',
        fontSize: 18,
        fontWeight: 'bold'
    }
  }),
);

interface PropsFromState {
  title: string;
  dataLoading: boolean;
  data: ProductsData[];
  language: string;
}

type AllProps = PropsFromState;

const ProductSlider: React.FC<AllProps> = ({
  title,
  dataLoading,
  data,
  language
}) => {

  const classes = useStyles();
  const products = Array.isArray(data) ? data.filter(item => item?.code && item?.title) : [];

  return (
    <>
    {!dataLoading && products.length ? (
    <Box pt={2} pb={1} pl={2} pr={2} bgcolor="#f9f9f9" className={classes.sliderBox}>
      {title ? (
          <Box pb={2}><FormattedMessage id={title} /></Box>
      ) : ( null )}
      <div className={classes.root}>
        {products.map((item) => (
          <div className={classes.productTile} key={item.code}>
            <ProductCard product={item} language={language} />
          </div>
        ))}
      </div>
    </Box>
    ) : null}
    </>
  );
};

const mapStateToProps = ({ products, user, language }: ApplicationState) => ({
  loading: products.loading,
  errors: products.errors,
  products: products.products,
  token: user.user["token"],
  language: language.language
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSlider);
